import { render, staticRenderFns } from "./CertificateListPage.vue?vue&type=template&id=c5554b84&"
import script from "./CertificateListPage.vue?vue&type=script&lang=js&"
export * from "./CertificateListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports